// extracted by mini-css-extract-plugin
export default {"navBar":"styles_navBar__CZkcv","navBar__right":"styles_navBar__right__gS2Vc","hasNotifications":"styles_hasNotifications__3BU6W"};